var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageAvailability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456",
    transform: "translate(-1192.5 -245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 245)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(1204.5 257.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M17.906,3.755V2.063a.813.813,0,1,0-1.626,0V3.69H9.232V2.063a.813.813,0,0,0-1.626,0V3.755A4.606,4.606,0,0,0,3.04,8.363a.545.545,0,0,0,.542.575H21.929a.538.538,0,0,0,.542-.575,4.606,4.606,0,0,0-4.565-4.608Z",
    transform: "translate(0.003 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M21.434,9.84H4.084A1.088,1.088,0,0,0,3,10.924V17.6c0,3.253,1.626,5.422,5.422,5.422H17.1c3.8,0,5.422-2.169,5.422-5.422V10.924A1.088,1.088,0,0,0,21.434,9.84Zm-11.7,9.076a1.709,1.709,0,0,1-.163.13.821.821,0,0,1-.2.1.689.689,0,0,1-.2.065,1.47,1.47,0,0,1-.217.022,1.079,1.079,0,0,1-.412-.087,1.119,1.119,0,0,1-.358-.228,1.1,1.1,0,0,1,0-1.54,1.119,1.119,0,0,1,.358-.228,1.037,1.037,0,0,1,.629-.065.689.689,0,0,1,.2.065.821.821,0,0,1,.2.1l.163.13a1.1,1.1,0,0,1,0,1.54Zm0-3.8a1.089,1.089,0,0,1-1.54-1.54,1.083,1.083,0,0,1,1.182-.228,1.012,1.012,0,0,1,.358.228,1.1,1.1,0,0,1,0,1.54Zm3.8,3.8a1.1,1.1,0,1,1,.314-.77A1.14,1.14,0,0,1,13.529,18.916Zm0-3.8-.163.13a.821.821,0,0,1-.2.1.689.689,0,0,1-.2.065,1.469,1.469,0,0,1-.217.022,1.089,1.089,0,0,1-.77-1.854,1.012,1.012,0,0,1,.358-.228,1.083,1.083,0,0,1,1.182.228,1.1,1.1,0,0,1,0,1.54Zm3.8,3.8a1.1,1.1,0,1,1,.314-.77A1.14,1.14,0,0,1,17.324,18.916Zm0-3.8-.163.13a.821.821,0,0,1-.2.1.689.689,0,0,1-.2.065,1.629,1.629,0,0,1-.217.022,1.089,1.089,0,0,1-.77-1.854,1.119,1.119,0,0,1,.358-.228,1.037,1.037,0,0,1,.629-.065.689.689,0,0,1,.2.065.821.821,0,0,1,.2.1l.163.13a1.1,1.1,0,0,1,0,1.54Z",
    transform: "translate(0 0.724)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAvailability);
export default __webpack_public_path__ + "static/media/manageAvailability.ce0df3a6b7646f8678ce03a312408fca.svg";
export { ForwardRef as ReactComponent };